import { type fabric } from 'fabric';
import { isShape, isSimpleGroup, isWireframe } from '../objects/guards';

export function fireCreatedDeep(obj: fabric.Object): void {
  obj.fire('created');
  if (isSimpleGroup(obj)) {
    obj.forEachObjectDeep(o => {
      o.fire('created');
    });
  }
}

// Determines if every object in objects is of the same type.
// For shapes and wireframes, it also checks against the subtype.
export function sameObjectType(objects: fabric.Object[]) {
  return objects.every((obj, _, array) => {
    if (isShape(obj)) {
      return isShape(array[0]) && obj.shapeName === array[0].shapeName;
    }

    if (isWireframe(obj)) {
      return (
        isWireframe(array[0]) && obj.wireframeName === array[0].wireframeName
      );
    }

    return obj.type === array[0].type;
  });
}

export function inGroup(obj: fabric.Object | undefined): boolean {
  return Boolean(obj?.simpleGroup && isSimpleGroup(obj?.simpleGroup));
}

export function objectType(obj: fabric.Object): string {
  if (isShape(obj)) {
    return obj.shapeName;
  } else if (isWireframe(obj)) {
    return obj.wireframeName;
  }

  return obj.type;
}
